'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _autolinker = require('autolinker');

var _autolinker2 = _interopRequireDefault(_autolinker);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _PubNubMessageStatusTypes = require('conversations-schema/constants/PubNubMessageStatusTypes');

var _PubNubMessageStatusTypes2 = _interopRequireDefault(_PubNubMessageStatusTypes);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatBubble = _react2.default.createClass({
  displayName: 'ChatBubble',

  propTypes: {
    className: _react.PropTypes.string,
    message: _react.PropTypes.object,
    messageRole: _react.PropTypes.oneOf((0, _underscore.values)(_RoleTypes2.default)).isRequired,
    currentRole: _react.PropTypes.oneOf((0, _underscore.values)(_RoleTypes2.default)).isRequired,
    isFirstInGroup: _react.PropTypes.bool,
    isLastInGroup: _react.PropTypes.bool,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default),
    children: _react.PropTypes.node
  },

  isSelfText: function isSelfText() {
    var _props = this.props,
        messageRole = _props.messageRole,
        currentRole = _props.currentRole;

    return currentRole === messageRole;
  },
  isRepText: function isRepText() {
    var currentRole = this.props.currentRole;

    return this.isSelfText() && currentRole === _RoleTypes2.default.REP;
  },
  isAdminScreen: function isAdminScreen() {
    return this.props.currentRole === _RoleTypes2.default.REP;
  },
  getClassName: function getClassName() {
    var _props2 = this.props,
        isLastInGroup = _props2.isLastInGroup,
        isFirstInGroup = _props2.isFirstInGroup,
        className = _props2.className,
        message = _props2.message;


    var isSelfText = this.isSelfText();
    var isRepText = this.isRepText();
    var hasBeenPublished = (0, _PubNubMessageModel.getStatus)(message) === _PubNubMessageStatusTypes2.default.PUBLISHED;

    return (0, _reactUtils.classNames)('chat-bubble', className, {
      'is-admin-screen': this.isAdminScreen(),
      'sender-text': isSelfText,
      'recipient-text': !isSelfText,
      'rep-color': isRepText,
      'last-in-group': isLastInGroup,
      'first-in-group': isFirstInGroup,
      sent: hasBeenPublished,
      offline: (0, _ConversationalMessageModel.isOfflineMessage)(message)
    });
  },
  getMessageStyle: function getMessageStyle() {
    var coloring = this.props.coloring;


    var isSelfText = this.isSelfText() && !this.isRepText();

    if (!coloring || !isSelfText) {
      return null;
    }

    return {
      backgroundColor: coloring.accentColor,
      color: coloring.textColor
    };
  },
  renderContent: function renderContent() {
    var message = this.props.message;


    var content = (0, _ConversationalMessageModel.getRichText)(message);
    var parsedContent = _autolinker2.default.link(content);

    return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: parsedContent } });
  },
  render: function render() {
    var children = this.props.children;

    var content = children || this.renderContent();

    return _react2.default.createElement(
      'div',
      { className: this.getClassName(), style: this.getMessageStyle() },
      _react2.default.createElement(
        'div',
        { className: 'chat-bubble-content flex-column' },
        content
      )
    );
  }
});

exports.default = ChatBubble;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/ChatBubble.js
// module id = 111
// module chunks = 0 1